import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
export default class TopContendersGrid extends Component {
  view() {
    const entries = this.attrs.entries;
    if (entries.length === 0) {
      return null;
    }
    const pointsLabel = app.forum.attribute('huseyinfiliz-leaderboard.points_label') || 'Points';
    return m("div", {
      className: "LeaderboardContenders"
    }, m("h3", {
      className: "LeaderboardContenders-title"
    }, m("i", {
      className: "fas fa-medal"
    }), app.translator.trans('huseyinfiliz-leaderboard.forum.contenders.title')), m("div", {
      className: "LeaderboardContenders-grid"
    }, entries.map(entry => {
      const user = entry.user();
      const rank = entry.rank();
      return m(Link, {
        href: user ? app.route('user', {
          username: user.slug()
        }) : '#',
        className: "LeaderboardContenders-card",
        key: entry.id()
      }, m("span", {
        className: "LeaderboardContenders-rank"
      }, "#", rank), m("div", {
        className: "LeaderboardContenders-avatar"
      }, user ? m(Avatar, {
        user: user
      }) : m("span", {
        className: "Avatar"
      }, "?")), m("span", {
        className: "LeaderboardContenders-name"
      }, user ? user.displayName() : '?'), m("span", {
        className: "LeaderboardContenders-points"
      }, entry.points(), " ", pointsLabel));
    })));
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/components/TopContendersGrid', TopContendersGrid);